// 提案メニュー（5種）
export const PROPOSAL_MENUS = [
  '第一想起取れるくん',
  '獲得取れるくん',
  'インハウスキャンプ',
  'IFキャスティング',
  '運用コックピット'
];

// パートナー向け提案メニュー（6種：他社案件を含む）
export const PARTNER_PROPOSAL_MENUS = [
  '第一想起取れるくん',
  '獲得取れるくん',
  'インハウスキャンプ',
  'IFキャスティング',
  '運用コックピット',
  '他社案件'
];

// 営業対応者（3名）
export const SALES_REPRESENTATIVES = [
  '増田 陽',
  '渡邊 哲成',
  '加藤 修慈'
];

// ステータス（8種）Ver 2.4統一版
export const STATUSES = [
  'アポ打診中',
  '初回アポ予定',
  '与件化_提案中',
  '受注',
  '失注',
  '保留',
  '検討中',
  '稼働終了'
];

// 紹介者の稼働状況
export const INTRODUCER_STATUS = [
  'アクティブ',
  '非稼働',
  '要確認'
];

// ステータスごとの色 Ver 2.4統一版
export const STATUS_COLORS = {
  'アポ打診中': '#e74c3c',
  '初回アポ予定': '#f39c12',
  '与件化_提案中': '#3498db',
  '受注': '#27ae60',
  '失注': '#e67e22',
  '保留': '#95a5a6',
  '検討中': '#9b59b6',
  '稼働終了': '#34495e'
};

// ステータスの順序（カンバンボード用）Ver 2.4統一版
export const STATUS_ORDER = [
  'アポ打診中',
  '初回アポ予定',
  '与件化_提案中',
  '受注',
  '失注',
  '保留',
  '検討中',
  '稼働終了'
];

// 部署名（Ver 2.13追加）
export const DEPARTMENT_NAMES = [
  'Buzz',
  'コンサル',
  'デジコン',
  'マーケD'
]; 